import {
  SeV2QuestionDto,
  useGetSourcingEventQuery,
  useSendSeV2ClarificationMessageAsBuyerMutation,
} from "../../../../autogen/bff-api";
import { ClarificationReplyForm } from "../../../../common/components/communication/ClarificationReplyForm";
import { ClarificationThread } from "../../../../common/components/communication/ClarificationThread";
import { useMessageAttachments } from "../../../../common/components/communication/useMessageAttachments";
import { useApiError } from "../../../../common/errors/useApiError";

export const BuyerClarificationThread = ({
  eventId,
  clarification,
}: {
  eventId: string;
  clarification: SeV2QuestionDto;
}) => {
  const displayer = useApiError();
  const [sendMessage, { isLoading }] = useSendSeV2ClarificationMessageAsBuyerMutation();
  const { data: event } = useGetSourcingEventQuery({ eventId });
  const requestDocuments = (event?.eventData.documents ?? []).map((d) => ({ id: d.id, name: d.name }));
  const attachments = useMessageAttachments({
    eventId,
    uploadEntityType: "SeV2AnswerAttachment",
    pollRole: "buyer",
    questionId: clarification.id,
  });

  const handleSend = async (content: string) => {
    try {
      await sendMessage({
        eventId,
        questionId: clarification.id,
        createSeV2QuestionMessageRequest: { content, attachments: attachments.toInputs() },
      }).unwrap();
      return true;
    } catch (error) {
      displayer.trigger(error);
      return false;
    }
  };

  return (
    <ClarificationThread
      question={clarification}
      viewerIsBuyer
      footer={
        <ClarificationReplyForm
          attachments={attachments}
          requestDocuments={requestDocuments}
          isSending={isLoading}
          onSend={handleSend}
        />
      }
    />
  );
};
